import LanguageSlice from './LanguageSlice';

export default LanguageSlice.actions;
